import React, { useState, useEffect,useRef } from "react";
import AxiosInstance from '../AxiosInstance';
import { FaCheck, FaTimes } from "react-icons/fa";
import Layout from './Layout';
import { ArrowLeftCircle } from "react-bootstrap-icons";
import { Button ,Col,Row} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ToastNotification from "../ToastNotification";
const Leaves = () => {
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [activeTab, setActiveTab] = useState("pending"); 
  const [selectedLeave, setSelectedLeave] = useState(null); 
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false); 
  const [rejectionReason, setRejectionReason] = useState(''); 
  const [rejectionReasons, setRejectionReasons] = useState([]); 
  const toastRef = useRef(null);
  const navigate=useNavigate();

  useEffect(() => {
    AxiosInstance.get("/admin/leavestatus")
      .then((response) => {
        setLeaveRequests(response.data);
      })
      .catch((error) => {
        toastRef.current.showToast("Failed to load leave requests. Please try again later.", "danger");
      });
  
    AxiosInstance.get("/common/leaveReasons")
      .then((response) => {
        setRejectionReasons(response.data);
      })
      .catch((error) => {
        toastRef.current.showToast("Failed to load rejection reasons. Please try again later.", "danger");
      });
  }, []);
  
  const filterLeaves = (status) => {
    return leaveRequests.filter(request => request.status === status);
  };

  const handleAccept = (leaveId, empId, leaveType, startDate, endDate) => {
    const formattedStartDate = new Date(startDate).toISOString().slice(0, 19).replace('T', ' ');
    const formattedEndDate = new Date(endDate).toISOString().slice(0, 19).replace('T', ' ');

    const leaveTypeId = leaveRequests.find(request => request.leave_type === leaveType)?.leave_type_id;
    const payload = {
        leaveId: leaveId,
        empId: empId,
        leaveTypeId: leaveTypeId, 
        startDate: formattedStartDate,
        endDate: formattedEndDate,
    };

    AxiosInstance.post('/admin/accept-leave', payload)
        .then(() => {
            toastRef.current.showToast('Leave accepted successfully', 'success');
            return AxiosInstance.get("/admin/leavestatus");
        })
        .then((response) => {
            setLeaveRequests(response.data); 
        })
        .catch((error) => {
            toastRef.current.showToast("Failed to accept leave. Please try again.", 'danger');
        });
};
  
  const handleReject = (leaveId) => {
    setSelectedLeave(leaveRequests.find((leave) => leave.id === leaveId)); // Set the selected leave
    setIsRejectModalOpen(true); 
  };

   const formatDate = (date) => {
    const d = new Date(date);
    return `${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}-${d.getFullYear()}`;
  };


  const formatAppliedDate = (date) => {
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${String(d.getFullYear()).slice(2)} | ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  };

  return (
    <Layout heading="Leave Requests">
    <Row className="mb-3">
      <Col xs={12}>
          <Button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
            <ArrowLeftCircle />
          </Button>
      </Col>
    </Row>
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <ul className="nav nav-tabs flex-column flex-md-row">
            <li className="nav-item col-12 col-md-auto p-1">
              <button
                className={`nav-link w-100 ${activeTab === "pending" ? "active" : "text-dark"}`}
                onClick={() => setActiveTab("pending")}
              >
                Pending Leaves
              </button>
            </li>
            <li className="nav-item col-12 col-md-auto p-1">
              <button
                className={`nav-link w-100 ${activeTab === "accepted" ? "active" : "text-dark"}`}
                onClick={() => setActiveTab("accepted")}
              >
                Approved Leaves
              </button>
            </li>
            <li className="nav-item col-12 col-md-auto p-1">
              <button
                className={`nav-link w-100 ${activeTab === "rejected" ? "active" : "text-dark"}`}
                onClick={() => setActiveTab("rejected")}
              >
                Rejected Leaves
              </button>
            </li>
          </ul>
        </div>
      </div>
      
      {/* Mobile View (scrollable on small screens only) */}
  <div className="row mt-3">
  <div className="col-12 d-block d-md-none">
    <div className="table-responsive d-block d-md-none" style={{ maxHeight: "300px", overflowY: "auto" }}>
      <table className="table table-hover text-center align-middle table-striped">
        <thead className="table-primary">
          <tr>
            <th>Employee Name</th>
            <th>Department</th>
            <th>From</th>
            <th>To</th>
            <th>Applied On</th>
            {activeTab === "pending" && <th>Actions</th>}
            {activeTab === "rejected" && <th>Rejection Reason</th>}
          </tr>
        </thead>
        <tbody>
          {filterLeaves(activeTab).length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">No leave requests found</td>
            </tr>
          ) : (
            filterLeaves(activeTab).map((request) => (
            <React.Fragment key={request.id}>
              <tr
                className={selectedLeave && selectedLeave.id === request.id ? "table-active" : ""}
                onClick={() => setSelectedLeave(selectedLeave?.id === request.id ? null : request)}
                style={{ cursor: "pointer" }}
              >
                <td className="py-3 text-start">{request.full_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}</td>
                <td className="py-3 text-start">{request.department_name}</td>
                <td className="py-3 text-start">{formatDate(request.start_date)}</td>
                <td className="py-3 text-start">{formatDate(request.end_date)}</td>
                <td className="py-3 text-start" style={{ whiteSpace: "nowrap" }}>{formatAppliedDate(request.submitted_at)}</td>

                {activeTab === "pending" && (
                  <td className="py-3 align-middle" style={{ width: "120px" }}>
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAccept(request.id, request.employee_id, request.leave_type, request.start_date, request.end_date);
                        }}
                      >
                        <FaCheck />
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleReject(request.id); 
                        }}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  </td>
                )}

                {activeTab === "rejected" && (
                  <td className="py-3 align-middle">{request.rejection_reason || "No reason provided"}</td>
                )}
              </tr>

              {/* Inline expandable row */}
              {selectedLeave?.id === request.id && (
                <tr className="bg-light">
                  <td colSpan={activeTab === "pending" || activeTab === "rejected" ? 6 : 5}>
                    <div className="p-3 border rounded text-start">
                      <h6 className="fw-bold">Leave Details</h6>
                      <p><strong>Employee Name:</strong> {request.full_name}</p>
                      <p><strong>Reason:</strong> {request.reason}</p>
                      <p><strong>Leave Type:</strong> {request.leave_type || "Not specified"}</p>
                      <div className="text-end">
                        <button
                          className="btn btn-sm btn-outline-secondary"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedLeave(null);
                          }}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))
          )}
        </tbody>

      </table>
    </div>
  </div>
  {/* Desktop View */}
<div className="col-12 d-none d-md-block">
  <div className="table-responsive" style={{ maxHeight: "500px", overflowY: "auto" }}>
    <table className="table table-hover text-center align-middle table-striped">
      <thead className="table-primary">
        <tr>
          <th className="text-start">Employee Name</th>
          <th  className="text-start">Department</th>
          <th  className="text-start">From</th>
          <th  className="text-start">To</th>
          <th  className="text-start">Applied On</th>
          {activeTab === "pending" && <th>Actions</th>}
          {activeTab === "rejected" && <th>Rejection Reason</th>}
        </tr>
      </thead>
      <tbody>
        {filterLeaves(activeTab).length === 0 ? (
          <tr>
            <td colSpan="6" className="text-center">No leave requests found</td>
          </tr>
        ) : (
          filterLeaves(activeTab).map((request) => (
  <React.Fragment key={request.id}>
    <tr
      className={selectedLeave && selectedLeave.id === request.id ? "table-active" : ""}
      onClick={() => setSelectedLeave(selectedLeave?.id === request.id ? null : request)}
      style={{ cursor: "pointer" }}
    >
      <td className="py-3 text-start">{request.full_name.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')}</td>
      <td className="py-3 text-start">{request.department_name}</td>
      <td className="py-3 text-start">{formatDate(request.start_date)}</td>
      <td className="py-3 text-start">{formatDate(request.end_date)}</td>
      <td className="py-3 text-start" style={{ whiteSpace: "nowrap" }}>{formatAppliedDate(request.submitted_at)}</td>

      {activeTab === "pending" && (
        <td className="py-3 align-middle" style={{ width: "120px" }}>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <button
              className="btn btn-success btn-sm"
              onClick={(e) => {
                e.stopPropagation();
                handleAccept(request.id, request.employee_id, request.leave_type, request.start_date, request.end_date);
              }}
            >
              <FaCheck />
            </button>
            <button
              className="btn btn-danger btn-sm"
              onClick={(e) => {
                e.stopPropagation();
                handleReject(request.id); 
              }}
            >
              <FaTimes />
            </button>
          </div>
        </td>
      )}

      {activeTab === "rejected" && (
        <td className="py-3 align-middle">{request.rejection_reason || "No reason provided"}</td>
      )}
    </tr>

    {/* Inline expandable row */}
    {selectedLeave?.id === request.id && (
      <tr className="bg-light">
        <td colSpan={activeTab === "pending" || activeTab === "rejected" ? 6 : 5}>
          <div className="p-3 border rounded text-start">
            <h6 className="fw-bold">Leave Details</h6>
            <p><strong>Employee Name:</strong> {request.full_name}</p>
            <p><strong>Reason:</strong> {request.reason}</p>
            <p><strong>Leave Type:</strong> {request.leave_type || "Not specified"}</p>
            <div className="text-end">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedLeave(null);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </td>
      </tr>
    )}
  </React.Fragment>
))

        )}
      </tbody>
    </table>
  </div>
</div>

</div>

  
        {isRejectModalOpen && (
          <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLongTitle">Reject Leave</h5>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label htmlFor="rejectionReason">Select Rejection Reason:</label>
                    <select
                      id="rejectionReason"
                      className="form-control"
                      value={rejectionReason}
                      onChange={(e) => setRejectionReason(e.target.value)}
                    >
                      <option value="">Select a reason</option>
                      {rejectionReasons.map((reason) => (
                        <option key={reason.id} value={reason.reason}>
                          {reason.reason}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setIsRejectModalOpen(false)}>
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      if (rejectionReason) {
                        AxiosInstance.post('/admin/reject-leave', {
                          leaveId: selectedLeave.id,
                          rejectReason: rejectionReason,
                        })
                        .then(() => {
                          toastRef.current.showToast('Leave rejected successfully', 'success');
                          return AxiosInstance.get("/admin/leavestatus");
                        })
                        .then((response) => {
                          setLeaveRequests(response.data);
                          setIsRejectModalOpen(false);
                          setRejectionReason('');
                        })
                        .catch((error) => {
                          toastRef.current.showToast("Failed to reject leave. Please try again.", 'danger');
                        });
                      } else {
                        toastRef.current.showToast("Please select a rejection reason.", 'warning');
                      }
                    }}
                  >
                    Reject Leave
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <ToastNotification ref={toastRef} />
    </Layout>
  );
};

export default Leaves;
